import CircleCheck from 'Components/Atoms/Icon/CircleCheck';
import useFirstSteps from 'Hooks/useFirstSteps';
import FirstStepsGroupItem from 'Pages/FirstSteps/FirstStepsGroupItem';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function OnboardingFirstSteps({ onClose }) {
    const { t } = useTranslation('onboarding');

    const { navigateToGroup, groups } = useFirstSteps();

    const handleNavigateToGroup = (groupId) => {
        navigateToGroup(groupId);
        onClose();
    };

    return (
        <div className="py-8">
            <div className="flex flex-col max-w-sm mx-auto items-center text-center mb-8">
                <div className="flex text-success pb-4">
                    <CircleCheck size={48} color="currentColor" />
                </div>
                <div className="text-xl sm:text-2xl text-pretty font-semibold text-dark-blue mb-2">
                    {t('account-created')}
                </div>
                <div className="sm:text-lg text-gray-500 text-pretty">{t('where-would-you-like-to-start')}</div>
            </div>

            <div className="grid gap-3">
                {groups.map((group) => (
                    <FirstStepsGroupItem
                        key={group.id}
                        title={group.title}
                        description={group.description}
                        icon={group.icon}
                        onClick={() => handleNavigateToGroup(group.id)}
                        iconClassName={group.iconClassName}
                    />
                ))}
            </div>
            <div className="flex justify-center pt-6">
                <button
                    type="button"
                    onClick={() => onClose()}
                    className="text-xs underline hover:no-underline text-gray-400 hover:text-gray-700 transition-colors"
                >
                    {t('perhaps-later')}
                </button>
            </div>
        </div>
    );
}

OnboardingFirstSteps.propTypes = {
    onClose: PropTypes.func.isRequired,
};
